import { useSocket } from '../context/SocketContext';
import { useInteractionStore } from '../stores/useInteractionStore';

/**
 * 🟢 Hook para monitorear y gestionar la conexión en entorno de Render.com
 * Proporciona estado de conexión, retry logic y heartbeat status
 */
export const useConnectionHealth = () => {
  const { socket } = useSocket();
  const retryFetchFriendsData = useInteractionStore((state) => state.retryFetchFriendsData);
  const retryCount = useInteractionStore((state) => state.retryCount);
  const maxRetries = useInteractionStore((state) => state.maxRetries);
  const lastError = useInteractionStore((state) => state.lastError);

  const getConnectionStatus = () => {
    if (!socket) return 'disconnected';
    if (socket.connected) return 'connected';
    if (socket.disconnected) return 'disconnected';
    return 'unknown';
  };

  const getSocketHealth = () => {
    return {
      connected: socket?.connected || false,
      id: socket?.id || null,
      transport: socket?.io?.engine?.transport?.name || 'unknown',
      latency: socket?.ackTimeout || null,
    };
  };

  const retryFriends = async () => {
    console.log('[ConnectionHealth] 🔄 Reintentando cargar amigos...');
    return retryFetchFriendsData();
  };

  const getRetryStatus = () => {
    return {
      currentAttempt: retryCount,
      maxAttempts: maxRetries,
      canRetry: retryCount < maxRetries,
      lastError,
    };
  };

  return {
    connectionStatus: getConnectionStatus(),
    socketHealth: getSocketHealth(),
    retryFriends,
    retryStatus: getRetryStatus(),
  };
};
